<template>
    <Component
        :is="icon"
        class="icon stroke-current"
    />
</template>

<script setup>
    import { computed, defineAsyncComponent } from 'vue';
    import IconBug from '../../assets/icons/icon-bug.svg';

    defineOptions({
        name: 'Icon',
    });

    const props = defineProps({
        name: {
            type: String,
            default: '',
        },
    });

    const icons = import.meta.glob('../../assets/icons/*.svg', { eager: false });
    const icon = computed(() => {
        return defineAsyncComponent({
            loader: async () => {
                const iconPath = `../../assets/icons/${props.name}.svg`;
                const component = icons[iconPath];
                if (component) {
                    return await component();
                }

                return IconBug;
            },
            errorComponent: IconBug,
        });
    });
</script>
